import { services } from "../../../api";
import { ConfigResponse, TabWithCategories } from "../../../interfaces/api/chat/config";
import { store } from "../../../redux/store";
import { setCategories, setLoadingCategories } from "../../auth/login/reducer";

export const getCategoriesConfig = async (): Promise<boolean> => {
    try {
        store.dispatch(setLoadingCategories(true));
        const res = await services.chat.getConfig() as ConfigResponse;
        if (res.result !== 'success') {
            throw new Error('test');
        }
        const categoriesData = res.content.data.tabs_with_categories?.filter((item: TabWithCategories) => item.categories.length > 0) || [];
        store.dispatch(setCategories(categoriesData));
        return true;
    } catch (err) {
        store.dispatch(setLoadingCategories(false));
        return false;
    }
}